import React from 'react'
import { createPortal } from 'react-dom'
import { useOutletContext } from 'react-router'

export default React.memo(function SidebarExtension({ children }: React.PropsWithChildren) {
  const pageContext: any = useOutletContext()

  return (
    <>{pageContext?.sidebarExtension.current && createPortal(<>{children}</>, pageContext.sidebarExtension.current)}</>
  )
})
